import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
  OnyxAmountPipe,
  OnyxDataWidgetComponent,
  OnyxInformationHeadingComponent,
} from '@onyx/angular';
import { DictionaryCode } from '../../../../../../common/enums/dictionary-code';
import type { OrderCancellation } from '../../../../common/interfaces/order';

@Component({
  selector: 'app-order-modal-cancellation',
  imports: [
    OnyxInformationHeadingComponent,
    TranslatePipe,
    OnyxDataWidgetComponent,
    OnyxAmountPipe,
  ],
  templateUrl: './order-modal-cancellation.component.html',
  styleUrl: './order-modal-cancellation.component.scss',
})
export class OrderModalCancellationComponent {
  public readonly cancellation = input.required<OrderCancellation>();

  protected readonly I18N = 'orders.orderModal';

  protected readonly DictionaryCode = DictionaryCode;
}
